/**
 * Small hand-drawn accent marks. Custom-authored SVGs, stroke=currentColor
 * so they inherit whatever text color they sit inside. Used sparingly as
 * emphasis, not as a decorative icon set — see call sites.
 */

/** A loose, slightly imperfect circle. Wraps a key word or number. */
export function CircleScribble({ className = "", ...rest }) {
  return (
    <svg viewBox="0 0 220 90" fill="none" className={className} aria-hidden="true" {...rest}>
      <path
        d="M18 47C14 27 44 10 92 7c54-3 106 9 116 27 9 17-24 34-83 38C67 75 12 66 6 48"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** A hand-sketched checkmark. Used so a "selected" state reads without color alone. */
export function CheckScribble({ className = "", ...rest }) {
  return (
    <svg viewBox="0 0 28 22" fill="none" className={className} aria-hidden="true" {...rest}>
      <path
        d="M2 11.5 10.5 19 26 2"
        stroke="currentColor"
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** A short, curved connector arrow. Points from a proof point to its label. */
export function ArrowScribble({ className = "", ...rest }) {
  return (
    <svg viewBox="0 0 100 46" fill="none" className={className} aria-hidden="true" {...rest}>
      <path
        d="M4 8c30 4 58 14 78 28"
        stroke="currentColor"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <path
        d="M62 30c8 1 15 3 20 6-2 5-5 10-6 16"
        stroke="currentColor"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** A four-point spark burst. Marks a milestone moment. */
export function SparkBurst({ className = "", ...rest }) {
  return (
    <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true" {...rest}>
      <path
        d="M20 2c1 8 2 9 10 10-8 1-9 2-10 10-1-8-2-9-10-10 8-1 9-2 10-10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M33 27c.6 4 1 4.4 5 5-4 .6-4.4 1-5 5-.6-4-1-4.4-5-5 4-.6 4.4-1 5-5Z" fill="currentColor" />
    </svg>
  );
}

/** A loose underline stroke, thicker in the middle. Draws attention under a word. */
export function UnderlineScribble({ className = "", ...rest }) {
  return (
    <svg viewBox="0 0 180 16" fill="none" className={className} preserveAspectRatio="none" aria-hidden="true" {...rest}>
      <path
        d="M2 9c40-6 100-8 176 4"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
}
